import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'region'],

    data() {
        return {
            title: '',
            isLoading: false,
            selectedRegion: null,
            buttonName: 'Ažuriraj',
            newName: '',
            newPrice: 0,
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                if(this.region == null){
                    this.title = 'Dodaj region'
                    this.buttonName = 'Dodaj'
                }else{
                    this.selectedRegion = this.region;
                    this.title = 'Izmeni region: ' + this.region.name;
                    this.newName = this.region.name;
                    this.newPrice = this.region.price;
                }

            }
        },
        newName: function(val, oldVal) {
            this.hasError = '';
        },
        newPrice: function(val, oldVal) {
            this.hasError = '';
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeEditRegion')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successEditRegion')
        },

        successAdd(){
            this.$topnavbar.$emit('successAddRegion')
        },

        update: update,
        add: add,
        reset: reset,
    }
}

function add() {
    let _self =this;
    const newModel = {
        name: _self.newName,
        price: _self.newPrice
    };
    _self.isLoading = true;
    AdminApiService.createRegion(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successAdd();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom ažuriranja"
        })
}

function update() {
    if(this.newPrice.length === 0 ||
        this.newName.length === 0 ) {
        this.hasError = "Molimo popunite ime i cenu.";
        return;
    }
    if(this.region == null){
        this.add();
        return;
    }
    let _self =this;
    const newModel = {
        name: _self.newName,
        price: _self.newPrice
    };
    _self.isLoading = true;
    AdminApiService.updateRegion(newModel, _self.region.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom ažuriranja"
        })

}

function reset() {
    this.newPrice = 0;
    this.newName = '';
}



// WEBPACK FOOTER //
// ./src/modals/EditRegionModal.js